export const initOrder = function () {
  const linkOrder = document.querySelectorAll('[data-order]');
  const tableOrder = document.querySelectorAll('[data-order-table]');
  const tableOrderClose = document.querySelectorAll('[data-order-table-close]');
  const breakpoint = 768;
  const table = document.querySelector('.table-all--individual');
  if (table) {
    table.addEventListener('scroll', function () {
      const stickyBlock = table.querySelector('.table-all__inner.is-scroll');
      if (stickyBlock.length > 0) {
        stickyBlock.forEach((item) => {
          item.classList.add('is-scroll');
        })
      }

      if (table.scrollLeft == 0) {
        stickyBlock.forEach((item) => {
          item.classList.remove('is-scroll');
        })
      }
    });
  }

  if (window.innerWidth > breakpoint) {
    linkOrder.forEach((item) => {
      item.addEventListener('click', (i) => {
        i.preventDefault();
        const parent = item.closest('.table-all__td');
        if (parent) {
          parent.classList.add('is-active');
        }
      })
    })

    if (tableOrder) {
      tableOrder.forEach((item) => {
        item.addEventListener('click', (i) => {
          const evtTarget = i.target;
          if (evtTarget == item) {
            const parent = item.closest('.table-all__td');
            parent.classList.remove('is-active');
          }
        })
      })
    }

    if (tableOrderClose) {
      tableOrderClose.forEach((item) => {
        item.addEventListener('click', (i) => {
          const parent = item.closest('.table-all__td.is-active');
          if (parent) {
            parent.classList.remove('is-active');
          }
        })
      })
    }

    window.addEventListener("keydown", function (e) {
      if (e.keyCode == 27) {
        const tableOrderOpen = document.querySelector('.table-all__td.is-active');
        if (tableOrderOpen) {
          tableOrderOpen.classList.remove('is-active');
        }
      }
    }, true)
  }
}
